import {EquipmentTypeEnum} from '@/models/digital-document-queue-sender-transfer-protocol-form-model';
import i18n from '@/i18n/config';
import {LF} from '@/i18n/LF';

export function equipmentTypeNameFilter(type: EquipmentTypeEnum): string {
  switch (type) {
    case EquipmentTypeEnum.Mirrors:
      return i18n.t(LF.Mirrors) as string;
    case EquipmentTypeEnum.Helmet:
      return i18n.t(LF.Helmet) as string;
    case EquipmentTypeEnum.Gloves:
      return i18n.t(LF.Gloves) as string;
    case EquipmentTypeEnum.MotorCover:
      return i18n.t(LF.MotorCover) as string;
    case EquipmentTypeEnum.Lights:
      return i18n.t(LF.Lights) as string;
    case EquipmentTypeEnum.Keys:
      return i18n.t(LF.Keys) as string;
    case EquipmentTypeEnum.VehicleLiabilityInsurance:
      return i18n.t(LF.LiabilityInsurance) as string;
    case EquipmentTypeEnum.Manual:
      return i18n.t(LF.Manual) as string;
    case EquipmentTypeEnum.BoltTaxiLamp:
      return i18n.t(LF.BoltTaxiLamp) as string;
    case EquipmentTypeEnum.FireExtinguisher:
      return i18n.t(LF.FireExtinguisher) as string;
    case EquipmentTypeEnum.RepairKit:
      return i18n.t(LF.RepairKit) as string;
    case EquipmentTypeEnum.WarningTriangle:
      return i18n.t(LF.WarningTriangle) as string;
    case EquipmentTypeEnum.PhoneHolder:
      return i18n.t(LF.PhoneHolder) as string;
    case EquipmentTypeEnum.LPGAdapter:
      return i18n.t(LF.LPGAdapter) as string;
    case EquipmentTypeEnum.TaxiLicense:
      return i18n.t(LF.TaxiLicense) as string;
    case EquipmentTypeEnum.CarFirstAidKit:
      return i18n.t(LF.CarFirstAidKit) as string;
    case EquipmentTypeEnum.AMICFleetCard:
      return i18n.t(LF.AMICFleetCard) as string;
    case EquipmentTypeEnum.FenderPresence:
      return i18n.t(LF.FenderPresence) as string;
    case EquipmentTypeEnum.Flashlights:
      return i18n.t(LF.Flashlights) as string;
    case EquipmentTypeEnum.FoldingLock:
      return i18n.t(LF.FoldingLock) as string;
    case EquipmentTypeEnum.WaterProofPhoneBag:
      return i18n.t(LF.WaterProofPhoneBag) as string;
    case EquipmentTypeEnum.ChargedBattery:
      return i18n.t(LF.ChargedBattery) as string;
    case EquipmentTypeEnum.VehicleCharger:
      return i18n.t(LF.VehicleCharger) as string;
    case EquipmentTypeEnum.ChargingCable240V400V:
      return i18n.t(LF.ChargingCable240V400V) as string;
    default:
      return '';
  }
}
